import { useMutation } from '@apollo/client/react';
import { PushNotifications } from '@capacitor/push-notifications';
import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { DEVICE } from '../../../config';

import AddPushSubscriptionMutation from './AddPushSubscriptionMutation.graphql';
const isCapacitor = ['ANDROID', 'IOS'].includes(DEVICE);

const CapacitorNotificationsHandler = isCapacitor ? ({ enabled = true }) => {
    const [addPushSubscriptionMutation] = useMutation(AddPushSubscriptionMutation);
    const navigate = useNavigate();

    useLayoutEffect(() => {
        // Not enabled
        if (!enabled) {
            PushNotifications.unregister();
        }

        // Enabled
        if (enabled) {
            PushNotifications.requestPermissions().then(result => {
                if (result.receive === 'granted') {
                    PushNotifications.register();
                }
            });
        }

        // On token available
        const handleRegistrationEvent = async (e) => {
            console.log('🔔 Push Notifications token', e.detail.value);
            // Send to backend
            await addPushSubscriptionMutation({
                variables: {
                    input: {
                        type: DEVICE === 'ANDROID' ? 'ANDROID_PUSH' : '',
                        subscription: e.detail.value,
                    }
                }
            });
        };

        // On notification action performed
        const handleActionEvent = async (e) => {
            window.__CAPACITOR_PUSH_NOTIFICATION_PERFORMED__ = null;
            let data = null;
            try {
                data = JSON.parse(e.detail?.notification?.data?.raw || e.notification?.data?.raw);
            } catch (err) {
                console.error('Failed to parse notification data', err, e.detail || e);
            }

            console.log('🔔 Push Notifications redirect', data);

            // Redirect to the right page
            if (data?.data?.type === 'NOTIFICATION') {
                navigate(`/notifications/${data.data.id || 'unknown'}/`);
            }
            if (data?.data?.type === 'CHAT') {
                navigate(`/chats/${data.data.id || 'unknown'}/${data.data.slug || 'unknown'}`);
            }
        }

        // If the component is mounted and the event was already catched and buffered, handle it
        if (window.__CAPACITOR_PUSH_NOTIFICATION_PERFORMED__) {
            handleActionEvent(window.__CAPACITOR_PUSH_NOTIFICATION_PERFORMED__);
        }

        window.addEventListener('capacitor:pushNotifications:registration', handleRegistrationEvent);
        window.addEventListener('capacitor:pushNotifications:actionPerformed', handleActionEvent);
        return () => {
            window.removeEventListener('capacitor:pushNotifications:registration', handleRegistrationEvent);
            window.removeEventListener('capacitor:pushNotifications:actionPerformed', handleActionEvent);
        }

    }, [enabled, addPushSubscriptionMutation, navigate]);
} : () => null;

export default CapacitorNotificationsHandler;